<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder" (pointerover)="opItemHover($event)" (pointerleave)="opMenuVerlaten()">
    <ul class="dl-nodemenu">
        @if (!condtag || node.data('condstate') === condtag.state) {
            @if (effectiefModelleerniveau >= 40) {
                <li class="dl-nodemenu__item" data-uitleg="influence_positive" (click)="uitvoerChangeAction({type:'influence_positive'})" title="{{ 'ADD_INF_POS' | translate }}">
                    <a class="influence_positive"></a>
                </li>
            }
            @if (effectiefModelleerniveau >= 40) {
                <li class="dl-nodemenu__item" data-uitleg="influence_negative" (click)="uitvoerChangeAction({type:'influence_negative'})" title="{{ 'ADD_INF_NEG' | translate }}">
                    <a class="influence_negative"></a>
                </li>
            }
            <li class="dl-nodemenu__item" data-uitleg="proportionality_positive" (click)="uitvoerChangeAction({type:'proportionality_positive'})" title="{{ 'ADD_PROP_POS' | translate }}">
                <a class="proportionality_positive" [class.niveau-laag]="effectiefModelleerniveau < 40"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="proportionality_negative" (click)="uitvoerChangeAction({type:'proportionality_negative'})" title="{{ 'ADD_PROP_NEG' | translate }}">
                <a class="proportionality_negative" [class.niveau-laag]="effectiefModelleerniveau < 40"></a>
            </li>
            @if (effectiefModelleerniveau >= 50) {
                <li class="dl-nodemenu__item" data-uitleg="proportionality_multiply" (click)="uitvoerChangeAction({type:'proportionality_multiply'})" title="{{ 'ADD_PROP_MULTIPLY' | translate }}">
                    <a class="proportionality_multiply"></a>
                </li>
            }
            @if (effectiefModelleerniveau >= 50) {
                <li class="dl-nodemenu__item" data-uitleg="proportionality_divide" (click)="uitvoerChangeAction({type:'proportionality_divide'})" title="{{ 'ADD_PROP_DIVIDE' | translate }}">
                    <a class="proportionality_divide"></a>
                </li>
            }
            <li class="dl-nodemenu__item" (click)="uitvoerSwitchArgs()" title="{{ 'SWITCH_ARGS' | translate }}">
                <a class="switch_args"></a>
            </li>
        }
        <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
        <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
            <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
        </li>
    </ul>
</div>
